'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _balance = require('./balance');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_balance).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/balance/index.js
// module id = 442
// module chunks = 0